<div
    class="mw-custom text-nowrap"
    [ngClass]="{ 'rounded-3 p-2 border border-1 bg-module fw-semibold': showBorder() }"
    [ngbTooltip]="'artemisApp.editor.toolTip' | artemisTranslate"
>
    <div class="mb-2">
        <fa-icon [icon]="faCircleNotch" size="lg" animation="spin" class="me-2" />
        @if (isQueued()) {
            <span jhiTranslate="artemisApp.editor.queued"></span>
        } @else {
            <span jhiTranslate="artemisApp.editor.building"></span>
        }
        @if (estimatedRemaining() && estimatedRemaining() > 0) {
            <span> {{ estimatedRemaining() | artemisDurationFromSeconds }}</span>
        }
    </div>
    <div class="d-flex justify-content-center align-items-center gap-2 w-100">
        <div class="progress w-25" role="progressbar" [style.height.px]="3">
            <div
                class="progress-bar progress-bar-striped bg-warning"
                [ngClass]="{ 'no-transition': !isQueueProgressBarAnimated }"
                [style.opacity]="queueProgressBarOpacity"
                [style.width.%]="queueProgressBarValue"
            ></div>
        </div>
        <div class="progress w-75" role="progressbar" [style.height.px]="3">
            <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                [ngClass]="{ 'no-transition': !isBuildProgressBarAnimated }"
                [style.opacity]="buildProgressBarOpacity"
                [style.width.%]="buildProgressBarValue"
            ></div>
        </div>
    </div>
</div>
